// ======================================================================
// File: src/modules/ppe/transport/pages/TransportPage.jsx
// Module: PPE → Transport
// Purpose:
//   Main container page for Transport List
//   Pattern aligned with FollowupPage.jsx
// ======================================================================

import React from "react";
import TransportList from "../components/transport/TransportList";

export default function TransportPage() {
  return <TransportList />;
}
